import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }, "操作"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }, "状態"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-5" }, "納品書発行日"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-3" }, "送信日時")
], -1)
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_list_content_layout = _resolveComponent("list-content-layout")!
  const _component_confirm_delete_draft = _resolveComponent("confirm-delete-draft")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_list_content_layout, null, {
        header: _withCtx(() => [
          _createElementVNode("h1", null, [
            _createTextVNode("納品書一覧（"),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.company.name)
            }, null, 8, _hoisted_1),
            _createTextVNode("）")
          ])
        ]),
        operation: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: { name: 'Company' },
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" 戻る ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'AddDraftDeliverySlip', params: { companyKey: _ctx.company.key } },
              class: "btn btn-danger ml-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("納品書発行")
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_dismissible_alert, {
            color: "danger",
            message: _ctx.requestError
          }, null, 8, ["message"])
        ]),
        "table-header": _withCtx(() => [
          _hoisted_4
        ]),
        "table-body": _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slips, (s) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: s.serialNo
            }, [
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: { name: 'EditDraftDeliverySlip', params: { companyKey: _ctx.company.key, serialNo: s.serialNo } },
                  class: "btn btn-warning"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (s.isDraft)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger ml-2",
                      onClick: ($event: any) => (_ctx.deleteTarget = s)
                    }, _hoisted_9, 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_10, [
                (s.isDraft)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "下書き"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, "送付済み"))
              ]),
              _createElementVNode("td", {
                textContent: _toDisplayString(s.deliveryDate)
              }, null, 8, _hoisted_13),
              _createElementVNode("td", {
                textContent: _toDisplayString(s.sendDateTime)
              }, null, 8, _hoisted_14)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.deleteTarget != null)
          ? (_openBlock(), _createBlock(_component_confirm_delete_draft, {
              key: 0,
              "delivery-date": _ctx.deleteTarget.deliveryDate.toString(),
              "serial-no": _ctx.deleteTarget.serialNo,
              onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteTarget = null)),
              onDeleteSlip: _ctx.deleteSlip
            }, null, 8, ["delivery-date", "serial-no", "onDeleteSlip"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}